"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRReduxContext = void 0;
const react_1 = __importDefault(require("react"));
exports.SSRReduxContext = react_1.default.createContext(null);
//# sourceMappingURL=ssr-redux-context.js.map